export const urlForImage = (url: string): string =>
    url?.includes(process.env.SITE_URL_FOR_IMG)
        ? url
        : url?.startsWith('/')
        ? `${process.env.SITE_URL_FOR_IMG}${url?.substring(1)}`
        : `${process.env.SITE_URL_FOR_IMG}${url}`;
